// Logo wall data for the "Companies & projects" section.
//
// HOW TO ADD A LOGO
// 1. Put the logo file in src/assets/logos/ (SVG or transparent PNG, trimmed to the edges).
// 2. Import it below and add an entry. `logo: null` shows the name as a clean wordmark instead.
// 3. Only list companies/clients Usama has permission to show publicly.

import botsify from '../assets/logos/botsify.png';
import reachowl from '../assets/logos/reachowl.png';
import dotomat from '../assets/logos/dotomat.png';
import learnScratch from '../assets/logos/learn-scratch.png';
import screenWithMe from '../assets/logos/screenwithme.png';

// Companies Usama has worked with or for (employers, clients, partners, training clients).
// TODO: fill with the confirmed list from Usama.
export const companies = [
  // { name: 'Company name', role: 'Client', logo: companyLogo, url: 'https://example.com' },
];

// While `companies` is empty, show labelled placeholder tiles so the layout can be reviewed.
// Set to false (or fill the list) before launch.
export const showCompanyPlaceholders = false;
export const companyPlaceholderCount = 2; // fills the last row of the 4-column grid

// Products and projects Usama has founded or built.
export const projects = [
  { name: 'Botsify', role: 'Founder', logo: botsify, url: 'https://botsify.com' },
  { name: 'ReachOwl', role: 'Founder', logo: reachowl, url: 'https://reachowl.com' },
  { name: 'Dotomat', role: 'Founder', logo: dotomat, url: 'https://dotomat.com' },
  { name: 'Learn Scratch', role: 'Builder', logo: learnScratch, url: null },
  { name: 'Vocallify', role: 'Product', logo: null, url: null },
  { name: 'ScreenWith.me', role: 'Product', logo: screenWithMe, url: 'https://screenwith.me' },
];
